module.exports = __webpack_public_path__ + "static/media/healthpartners.e96e84fa.svg";